import { motion } from "framer-motion";
import { X } from "lucide-react";
import { useState } from "react";

export default function DevelopmentNoticeModal() {
  const [open, setOpen] = useState(true);
  const [lang, setLang] = useState("en");

  if (!open) return null;

  const content = {
    en: {
      title: "JanShakti",
      subtitle: "Citizen Power • Strengthening Democracy",
      dev: "This platform is currently in development stage.",
      desc: "JanShakti is being built to empower citizens to raise issues, track leaders, and participate in transparent governance.",
      warn: "Some features may be incomplete or under testing.",
      support: "We need your support and feedback to improve this platform.",
      neutral: "We do not support or promote any political party.",
      close: "Continue",
    },
    hi: {
      title: "जनशक्ति",
      subtitle: "नागरिक शक्ति • लोकतंत्र को मजबूत बनाना",
      dev: "यह प्लेटफॉर्म अभी विकास चरण में है।",
      desc: "जनशक्ति नागरिकों को सशक्त बनाने और नेताओं को ट्रैक करने के लिए बनाया जा रहा है।",
      warn: "कुछ फीचर्स अभी अधूरे या टेस्टिंग में हो सकते हैं।",
      support: "हमें आपके सहयोग और सुझाव की आवश्यकता है।",
      neutral: "हम किसी भी राजनीतिक पार्टी का समर्थन नहीं करते।",
      close: "आगे बढ़ें",
    },
  };

  const t = content[lang];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">

      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 40 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="relative w-[92%] max-w-2xl rounded-2xl shadow-2xl p-6 md:p-8 text-black"
        style={{
          background: "linear-gradient(135deg, #ff9933, #ffffff, #138808)",
        }}
      >

        {/* Close Button */}
        <button
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 text-red-600 hover:text-red-800"
        >
          <X size={26} />
        </button>

        {/* Language Toggle */}
        <div className="flex justify-end mb-2">
          <button
            onClick={() => setLang(lang === "en" ? "hi" : "en")}
            className="text-xs bg-black/10 px-3 py-1 rounded-full"
          >
            {lang === "en" ? "हिंदी" : "English"}
          </button>
        </div>

        {/* Header */}
        <div className="text-center mb-4">
          <h1 className="text-3xl font-bold text-black">{t.title}</h1>
          <p className="text-sm text-gray-700">{t.subtitle}</p>
        </div>

        {/* Content */}
        <div className="space-y-3 text-sm md:text-base leading-relaxed text-gray-800">

          <p>🚧 <strong>{t.dev}</strong></p>

          <p>{t.desc}</p>

          <p>⚠️ {t.warn}</p>

          <p>💡 <strong>{t.support}</strong></p>

          <p className="text-xs text-gray-700 border-t pt-3">
            ⚖️ {t.neutral}
          </p>

        </div>

        {/* Footer Button */}
        <div className="mt-6 text-center">
          <button
            onClick={() => setOpen(false)}
            className="px-6 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition"
          >
            {t.close}
          </button>
        </div>

      </motion.div>
    </div>
  );
}